import http from "@/http";
// ### 获取在线用户列表
// http://base.leubao.com/api/online/list
export const getOnlineList = {
  p: "/api/online/list",
  r: data => {
    return http({
      url: "/api/online/list",
      method: "post",
      data
    });
  }
};
//   ### 下线
//   http://base.leubao.com/api/online/offline
export const offlineUser = {
  p: "/api/online/offline",
  r: data => {
    return http({
      url: "/api/online/offline",
      method: "post",
      data
    });
  }
};
//   ### 全部下线
// http://base.leubao.com/api/online/offline_all
export const offlineUserAll = {
  p: "/api/online/offline_all",
  r: data => {
    return http({
      url: "/api/online/offline_all",
      method: "post",
      data
    });
  }
};
